import * as _ from 'lodash'
import { ServiceError, WebServiceBase, WebServiceResponse } from './WebServiceBase'

class OperationStatus {
  public static showChanges: boolean = true;

  public static fromResponse(response: WebServiceResponse): OperationStatus {
    return new OperationStatus().update(response);
  }

  public isBusy: boolean;
  public error: ServiceError;

  public constructor() {
    this.error = new ServiceError();
    this.clearError(undefined);
  }

  public clearError(shortMessage: string, fullMessage?: string): OperationStatus {
    return this.setState(false, 0, shortMessage || this.error.ShortMessage, this.error.Message);
  }

  public get isReady(): boolean {
    return !this.isBusy && !this.error.isError;
  }

  public setStarting(shortMessage: string, fullMessage?: string): OperationStatus {
    return this.setState(true, 0, shortMessage, fullMessage);
  }

  public setError(errorCode: number, shortMessage: string, fullMessage?: string): OperationStatus {
    return this.setState(false, errorCode, shortMessage, fullMessage);
  }

  public setState(isBusy: boolean, errorCode: number = 0, shortMessage?: string, fullMessage?: string): OperationStatus {
    this.isBusy = isBusy;
    this.error.ErrorCode = errorCode;
    this.error.ShortMessage = shortMessage;
    this.error.Message = fullMessage;

    //console.log("setState, isBusy: " + isBusy);
    if (OperationStatus.showChanges) {
      if (!this.isBusy && this.error.isError) {
        // tslint:disable-next-line:no-console
        //console.error('set' + this.toString());
      } else {
        // tslint:disable-next-line:no-console
        //console.log('set' + this.toString());
      }
    }

    return this;
  }

  public toString(): string {
    if (!this.isBusy && this.error.isError) {
      return 'state- error ' + this.error.ErrorCode
        + ', shortMessage: ' + this.error.ShortMessage
        + ', fullMessage: ' + this.error.Message;
    } else {
      return 'state- isBusy: ' + this.isBusy
        + ', shortMessage: ' + this.error.ShortMessage
        + ', fullMessage: ' + this.error.Message;
    }
  }

  public update(sr: WebServiceResponse): OperationStatus {
    this.error.Domain = sr.Error.Domain
    return this.setState(false, sr.Error.ErrorCode, sr.Error.Message, sr.Error.ShortMessage);
  }
}

export {
  OperationStatus
}



// WEBPACK FOOTER //
// ./src/app/services/OperationStatus.ts